<template>
  <div class="assess_div">
    <div class="service">
      <p>服务介绍</p>
      <div class="service_content">
        <span>评估监理服务：1､物业服务评估监理则按约定周期出具评估监理服务报告，一式三份递交甲方，具体甲乙双方按约定周期进行评估监理服务。2､根据小区的具体数据测算费用报甲方确认并签订评估监理服务协议，具体评估监理周期约定协议中。特别说明：电梯为每次抽检为20%。</span>
      </div>
    </div>
    <ul class="input_box">
      <li>
        <span>小区总面积(万平方)：</span>
        <input type="tel" v-model="area">
      </li>
      <li>
        <span>电梯数量：</span>
        <input type="tel" v-model="liftNum">
      </li>
      <li>
        <span>消监控室数量：</span>
        <input type="tel" v-model="monitor">
      </li>
    </ul>
    <div class="service_cycle">
      <p>服务周期价：{{cycle}}元</p>
      <div class="discount_btn" @click="clickNumber">
        <span>{{timeText}}</span>
        <img src="../home/images/drop_icon.png" alt="">
      </div>
    </div>
    <div class="cost">
      <span>单次价：{{total}}元/次</span>
      <span class="cost_detail" @click="goCost">费用明细</span>
    </div>
    <div class="post_btn">
      <button @click="postBtn" :class="{clickbtn:isDisable}" :disabled="isDisable">
        <span>{{btnTitle}}</span>
      </button>
    </div>
    <div class="explain">
      <h3>企业资质：</h3>
      <p>
        承接查验涉及电梯需有特种设备许可证,且查验技术人员持有电梯特种资格证书,并提供该查验人员的社保证明。
      </p>
      <p>涉及消防设施维护保养检测的消防技术服务机构,列入消防技术服务管理系统的目录库单位,应具有相关技术人员不得少于8人,其中一级注册消防工程师不少于2人,消防设施操作员国家职业资格证书不少于6人,其中中级技能等级的不少于2人。</p>
    </div>
    <!--折扣弹窗-->
    <mt-popup
      v-model="numberShow"
      position="bottom" :closeOnClickModal="orClose">
      <div class="count_list">
        <ul>
          <li v-for="(time, index) in timeData" :key="index" @click="choseTime(time)">
            <span>{{time.option}}</span>
          </li>
        </ul>
        <div class="close_btn" @click="closeNumber">取消</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import { checkOffer } from '../../api/my'
  import { Toast, Indicator } from 'mint-ui'
  export default {
    name: 'AssessMent',
    data () {
      return {
        numberShow: false,
        orClose: false,
        page: 'assess',
        area: '1', // 面积
        liftNum: '1', // 电梯数量
        monitor: '1', // 消监控数量
        total: '', // 总价
        timeData: [],
        timeText: '', // 次数
        cycle: '', // 对应周期价
        cycleDetail: [], // 对应周期明细
        isDisable: false, // 防止提交按钮重复提交(能点击)
        btnTitle: '查询',
        state: '' // 页面状态[判断是从那个页面进来的]
      }
    },
    created () {
      this.state = this.$route.query.state
      // console.log(this.state)
      if (this.state === 2) {
        this._getData()
      }
    },
    // 设置缓存从哪个页面返回
    beforeRouteEnter: (to, from, next) => {
      if (from.name === 'costDetail') {
        to.meta.isBack = true
      }
      next()
    },
    activated () {
      if (!this.$route.meta.isBack) {
        this._getData()
      }
      this.$route.meta.isBack = false
    },
    methods: {
      // 数据请求
      _getData() {
        checkOffer(this.area, this.liftNum, this.monitor).then(res => {
          // console.log(res)
          if (res.code === 200) {
            this.total = res.data.assess_total_money // 总金额
            this.timeData = res.data.assess
            // console.log(this.timeData)
            this.timeText = this.timeData[0].option // 默认次数标题
            this.cycle = this.timeData[0].total // 默认服务周期价格
            this.cycleDetail = this.timeData[0].details // 默认周期价格明细
          }
        })
      },

      // 点击打开次数弹窗
      clickNumber() {
        this.numberShow = true
      },
      // 取消次数弹窗
      closeNumber () {
        this.numberShow = false
      },
      // 选择次数
      choseTime (time) {
        // console.log(time)
        this.timeText = time.option // 对应次数标题
        this.cycle = time.total // 对应的服务周期价
        this.cycleDetail = time.details // 对应服务周期明细
        this.numberShow = false
      },
      // 提交
      postBtn () {
        this.isDisable = true
        if (!this.area && !this.liftNum && !this.monitor) {
          Toast({
            message: '请将信息填写完整！',
            position: 'middle',
            duration: 1500
          })
          this.isDisable = false
          return
        } else {
          Indicator.open({
            text: '查询中,请稍后',
            spinnerType: 'fading-circle'
          })
          checkOffer(this.area, this.liftNum, this.monitor).then(res => {
            // console.log(res)
            if (res.code === 200) {
              Indicator.close()
              this.total = res.data.assess_total_money // 总金额
              this.timeData = res.data.assess
              this.timeText = this.timeData[0].option // 次数标题
              this.cycle = this.timeData[0].total // 服务周期价格
              this.cycleDetail = this.timeData[0].details // 周期价格明细
            }
          })
          // 提交成功后设置1秒后才能点击
          setTimeout(() => {
            this.isDisable = false
            this.btnTitle = '查询'
          }, 1000)
          this.isDisable = true
          this.btnTitle = '查询中'
        }
      },
      // 去到费用明细
      goCost() {
        this.$router.push({
          path: '/my/costDetail/',
          query: {
            page: this.page,
            data: this.cycleDetail,
            money: this.cycle
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.assess_div{
  padding-top: 50px;
  .service{
    padding: 15px;
    p{
      color: #707070;
      font-size: 15px;
    }
    .service_content{
      padding: 10px;
      margin-top: 10px;
      border-radius: 10px;
      background: rgba(38, 165, 255, 0.5);
      color: #ffffff;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .input_box{
    li{
      width: 100%;
      /*padding: 15px;*/
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      span{
        font-size: 15px;
        color: #414141;
        margin-left: 15px;
      }
      input{
        width: 160px;
        padding: 5px;
        margin-right: 15px;
        border: 1px solid #26a5ff;
        outline: none;
        border-radius: 5px;
        color: #414141;
      }
    }
  }
  .service_cycle{
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    p{
      font-size: 16px;
      color: #ff9c39;
      font-weight: bolder;
      margin-left: 15px;
    }
    .discount_btn{
      padding: 5px 20px;
      background: #ff9c39;
      text-align: center;
      margin-right: 15px;
      border-radius: 15px;
      color: #ffffff;
      font-size: 15px;
    }
  }
  .cost{
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    color: #414141;
    margin-top: 15px;
    span{
      margin-left: 15px;
    }
    .cost_detail{
      color: #077bff;
      border-bottom:1px solid #077bff;
      margin: 5px 15px 5px 5px;
    }
  }
  .post_btn{
    text-align: right;
    margin-top: 10px;
    margin-right: 15px;
    button{
      padding: 10px 40px;
      font-size: 15px;
      color: #ffffff;
      background: #479DFF;
      display: inline-flex;
      align-items: center;
      span{
        margin-right: 10px;
      }
    }
    .clickbtn{
      padding: 10px 20px;
      font-size: 15px;
      color: #ffffff;
      background: #bcbcbc;
      display: inline-flex;
      align-items: center;
      span{
        margin-right: 10px;
      }
    }
  }
  .explain{
    margin-top: 20px;
    padding: 15px;
    h3{
      font-size: 14px;
      font-weight: normal;
      color: #BCBCBC;
    }
    p{
      font-size: 13px;
      color: #BCBCBC;
      margin-top: 10px;
      line-height: 20px;
    }
    p:last-child{
      margin-top: 0;
    }
  }
  .mint-popup-bottom{
    width: 100%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .count_list{
      width: 100%;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      ul{
        border-bottom: 10px solid #f2f2f2;
        li{
          text-align: center;
          font-size: 17px;
          border-bottom: 1px solid #f2f2f2;
          height: 60px;
          span{
            line-height: 60px;
          }
        }
      }
      .close_btn{
        font-size: 17px;
        line-height: 60px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/AssessMent.vue